import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "severities",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-severity" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
